import { IPlannerState } from '../types/planner-state.model';
import { IOpportunity } from '../types/ppg-sku-drawer.model';

function getList() {
  return [];
}
export function getNewOpportunitiesForRow(
  opportunities: number[],
  changedOpportunity: IOpportunity,
  isOpportunityRemoved: boolean
) {
  const newOpportunities = [...opportunities, changedOpportunity.pk_id].filter(
    (opp, index, self) => self.indexOf(opp) === index
  );
  if (isOpportunityRemoved) {
    return newOpportunities.filter((opp) => opp !== changedOpportunity.pk_id);
  }
  return newOpportunities;
}

export function setRowItemOpportunity(
  state: IPlannerState,
  arg: {
    parentIndex: number;
    childIndex: number;
    newOpportunities: number[];
    changedOpportunity: IOpportunity;
  }
) {
  const { childIndex, parentIndex, newOpportunities, changedOpportunity } = arg;
  const isOpportunityChecked =
    newOpportunities.indexOf(changedOpportunity.pk_id) > -1;
  //NOSONAR
  const ppgLevelOpportunities: any[] = getList();
  //NOSONAR
  const skuLevelOpportunities: any[] = getList();
  if (childIndex === null) {
    if (isOpportunityChecked) {
      state.bulkInputsMetadata.rows[parentIndex].opportunities =
        newOpportunities
          .filter(
            (opportunityId) =>
              !changedOpportunity.disables_opportunity.includes(opportunityId)
          )
          .filter((value, index, self) => self.indexOf(value) === index);
      state.bulkInputsMetadata.rows[parentIndex].subRows.forEach((child) => {
        if (!child.opportunities.includes(changedOpportunity.pk_id)) {
          child.opportunities.push(changedOpportunity.pk_id);
        }
        /**
         * Removing any of the opportunities in child that should be removed on check of current opportunity
         */
        // eslint-disable-next-line no-param-reassign
        child.opportunities = child.opportunities.filter(
          (opportunityId) =>
            !changedOpportunity.disables_opportunity.includes(opportunityId)
        );
      });
    } else {
      state.bulkInputsMetadata.rows[parentIndex].opportunities =
        newOpportunities;
      state.bulkInputsMetadata.rows[parentIndex].subRows.forEach((child) => {
        if (child.opportunities.includes(changedOpportunity.pk_id)) {
          child.opportunities.splice(
            child.opportunities.indexOf(changedOpportunity.pk_id),
            1
          );
        }
      });
    }
  } else if (
    skuLevelOpportunities.find((opp) => opp.pk_id === changedOpportunity.pk_id)
  ) {
    const parentRow = state.bulkInputsMetadata.rows[parentIndex];
    const childRows = parentRow.subRows;
    const child = childRows[childIndex];
    if (isOpportunityChecked) {
      child.opportunities = newOpportunities
        .filter(
          (opportunityId) =>
            !changedOpportunity.disables_opportunity.includes(opportunityId)
        )
        .filter((value, index, self) => self.indexOf(value) === index);
    } else {
      child.opportunities = newOpportunities;
    }
    parentRow.opportunities = ppgLevelOpportunities
      .map((opportunity) => {
        const childrenWithParentOpportunityId = parentRow.subRows.filter(
          (childProduct) =>
            childProduct.opportunities.includes(opportunity.pk_id)
        );
        if (!childrenWithParentOpportunityId.length) {
          return null;
        }
        if (
          childrenWithParentOpportunityId.length === parentRow.subRows.length
        ) {
          return opportunity.pk_id;
        }
        return opportunity.intermediate_opp_id;
      })
      .filter((opportunityId) => opportunityId !== null)
      .filter((value, index, self) => self.indexOf(value) === index);
  }
}
